module.exports = __webpack_public_path__ + "img/downloadIcon.11213618.svg";